const e = {
  parts: ["dropzone", "icon", "text"],
  baseStyle: {
    dropzone: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDir: "column",
      height: "full",
      borderRadius: "md",
      backgroundColor: "primary.50",
      minHeight: "282px"
    },
    icon: {
      width: 8,
      height: 8,
      direction: "column"
    },
    text: {
      textAlign: "center",
      lineHeight: "1.4"
    }
  }
};
export {
  e as Dropzone
};
//# sourceMappingURL=Dropzone.es.js.map
